// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__3eum3","right":"styles_right__1awBM"};